import React, { useContext, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Handle, useReactFlow } from "react-flow-renderer";
import { NodesContext } from "../provider/IvrContext";
import AudioPreviewModal from "../Helpers/AudioPreviewModel";
import { toast } from 'react-toastify';

const RecordNode = ({ data, id }) => {
    const { setNodes } = useReactFlow();

    const { updateNodeData, onRemove, audioList } = useContext(NodesContext)
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [playModalOpen, setPlayModalOpen] = useState(false);

    // ✅ derive from node data
    const action = data.action || {};
    const audioId = action.id || "";
    const audioUrl = action.audio || "";
    const audioName = action.name || "";
    const recordDuration = data.record_duration || "";

    const updateNode = (updates) => {
        updateNodeData(id, updates);
    };

    const handleAudioChange = (e) => {
        const selected = audioList.find(
            (a) => a.promptId.toString() === e.target.value
        );

        if (!selected) return;

        updateNode({
            action: {
                type: "record",
                id: selected.promptId,
                audio: selected.promptUrl,
                duration: selected.promptDuration ? selected.promptDuration : "",
                name: selected.fileName
            },
        });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!action?.id) {
            newErrors.audio = 'Audio is required';
        }
        if (recordDuration === "") {
            newErrors.record_duration = "Record duration is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {

        if (!validateForm()) return;

        toast.success("Details updated successfully");
        setModalIsOpen(false);
    };

    const handleDurationChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            updateNode({
                record_duration: value,
            });
        }
    }

    const handleRemoveNode = () => {
        if (data.parent === "gather Node" && data.idToRemove) {
            setNodes((nodes) =>
                nodes.map((node) => {
                    if (!node.data.selectedHandles) return node;

                    const updatedHandles = { ...node.data.selectedHandles };
                    const updatedSmsData = { ...node.data.smsData }
                    delete updatedHandles[data.idToRemove];
                    if (updatedSmsData) {
                        const parts = data.idToRemove.split('-');
                        const handleIndex = parts[parts.length - 1];
                        if (handleIndex) {
                            const smsKey = `DTMF_${handleIndex}`;
                            delete updatedSmsData[smsKey]
                        }
                    }
                    return {
                        ...node,
                        data: { ...node.data, selectedHandles: updatedHandles, smsData: updatedSmsData },
                    };
                })
            );
        }
        onRemove(id)
    };

    return (
        <div style={{ position: "relative", width: "120px", height: "40px" }}>
            <div
                style={{
                    position: "absolute",
                    top: "15px", // Positioned slightly down to make room for the mic handle
                    left: 0,
                    width: "100%",
                    height: "50px",
                    border: "2px solid #20c997",
                    borderRadius: "25px", // Pill Shape
                    background: "#fff",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px 10px",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                }}
            >
                <Handle type="target" position="top" style={{
                    transform: "translateX(-50%)",
                    background: "#20c997",
                    border: "2px solid #fff",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }} />
                <Handle type="source" position="bottom" style={{
                    transform: "translateX(-50%)",
                    background: "#dc3545", // Red Color
                    border: "2px solid #fff",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }} />

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "8px", fontWeight: "bold", textTransform: "capitalize", color: "#333" }}>
                        {data.label || "Record"}
                    </span>

                    <div style={{ display: "flex", gap: "5px" }}>
                        <i
                            className="fa fa-cog"
                            style={{ color: "#20c997", cursor: "pointer", fontSize: "11px" }}
                            onClick={() => setModalIsOpen(true)}
                            title="Settings"
                        />
                        <i
                            className="fa fa-trash"
                            style={{ color: "#dc3545", cursor: "pointer", fontSize: "11px" }}
                            onClick={handleRemoveNode}
                            title="Delete"
                        />
                        {audioUrl && (
                            <i
                                className="fa fa-play"
                                style={{ color: "#28a745", cursor: "pointer", fontSize: "11px" }}
                                title="Play audio"
                                onClick={() => setPlayModalOpen(true)}
                            />
                        )}
                    </div>
                </div>
            </div>

            <Modal
                size="lg"
                show={modalIsOpen}
                onHide={() => setModalIsOpen(false)}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Record</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Select Audio</Form.Label>
                            <Form.Control
                                as="select"
                                value={audioId}
                                onChange={handleAudioChange}
                            >
                                <option value="">Select Audio</option>
                                {audioList.map((item) => (
                                    <option key={item.promptId} value={item.promptId}>
                                        {item.fileName}
                                    </option>
                                ))}
                            </Form.Control>
                            {errors.audio && <Form.Text className="text-danger">{errors.audio}</Form.Text>}
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Record Duration (seconds)</Form.Label>
                            <Form.Control
                                type="number"
                                min="1"
                                step="1"
                                value={recordDuration}
                                onChange={handleDurationChange}
                                placeholder="Enter duration in seconds"
                            />
                            {errors.record_duration && (
                                <Form.Text className="text-danger">
                                    {errors.record_duration}
                                </Form.Text>
                            )}
                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleSave}>Save</Button>
                    <Button variant="secondary" onClick={() => setModalIsOpen(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={audioUrl}
                title={audioName}
            />

        </div>
    );
};

export default RecordNode;
